import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, TransitionGroup as _TransitionGroup, Transition as _Transition, withKeys as _withKeys, Teleport as _Teleport, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"min-height":"200px"}
}
const _hoisted_2 = { class: "p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_4 = { class: "flt-count" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_6 = { class: "flt-search" }
const _hoisted_7 = {
  class: "btn btn-sm btn-warning position-relative",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalExortToday"
}
const _hoisted_8 = { class: "badge bg-dark ms-1" }
const _hoisted_9 = {
  class: "flt-toolbar px-15 px-md-20",
  role: "toolbar",
  "aria-label": "Filtres des colis"
}
const _hoisted_10 = {
  class: "flt-seg",
  role: "group",
  "aria-label": "État de paiement"
}
const _hoisted_11 = ["aria-pressed", "onClick"]
const _hoisted_12 = { class: "flt-period" }
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = { class: "flt-trigger__text" }
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = {
  key: 0,
  class: "flt-badge"
}
const _hoisted_17 = {
  key: "etat",
  class: "flt-chip"
}
const _hoisted_18 = {
  key: "date",
  class: "flt-chip"
}
const _hoisted_19 = {
  key: "client",
  class: "flt-chip"
}
const _hoisted_20 = {
  key: "liv",
  class: "flt-chip"
}
const _hoisted_21 = {
  key: "status",
  class: "flt-chip"
}
const _hoisted_22 = {
  key: "zone",
  class: "flt-chip"
}
const _hoisted_23 = {
  key: "city",
  class: "flt-chip"
}
const _hoisted_24 = {
  key: "bpl",
  class: "flt-chip"
}
const _hoisted_25 = { class: "flt-drawer__head" }
const _hoisted_26 = { class: "flt-drawer__body" }
const _hoisted_27 = { class: "flt-section" }
const _hoisted_28 = { class: "flt-section" }
const _hoisted_29 = {
  class: "flt-options",
  role: "radiogroup",
  "aria-label": "Ajouté au BPL"
}
const _hoisted_30 = ["aria-checked", "onClick"]
const _hoisted_31 = { class: "flt-section" }
const _hoisted_32 = { class: "flt-drawer__foot" }
const _hoisted_33 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_34 = { class: "d-flex align-items-center mb-20" }
const _hoisted_35 = { class: "table-scroll-outer" }
const _hoisted_36 = { class: "table-scroll-mobile" }
const _hoisted_37 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_41 = {
  key: 1,
  class: "text-info"
}
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 3,
  class: "ph ph-package ms-2 text-primary fs-18",
  title: "Colis stock"
}
const _hoisted_44 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_45 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_46 = { class: "text-nowrap" }
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_50 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_51 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_52 = {
  key: 0,
  class: "refund-step-note d-block"
}
const _hoisted_53 = {
  key: 1,
  class: "mt-1 fs-12 text-primary fw-semibold"
}
const _hoisted_54 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_57 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_58 = { class: "dropdown" }
const _hoisted_59 = { class: "dropdown-menu" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["href"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { key: 2 }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { key: 3 }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { key: 4 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { key: 5 }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { key: 6 }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "shadow-none fw-medium text-black-emphasis refs-td" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 1,
  class: "refs-expanded"
}
const _hoisted_84 = { class: "refs-expanded__header" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "refs-list" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { key: 1 }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = { key: 2 }
const _hoisted_92 = ["href"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = ["onClick"]
const _hoisted_98 = ["href"]
const _hoisted_99 = { key: 9 }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { key: 10 }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { key: 11 }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { key: 12 }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = { class: "pagination-area d-flex flex-wrap mt-15 mt-md-25 mb-0 justify-content-between align-items-center gap-2" }
const _hoisted_109 = { class: "d-flex align-items-center" }
const _hoisted_110 = { class: "mb-0 text-paragraph" }
const _hoisted_111 = { class: "fw-bold" }
const _hoisted_112 = { class: "fw-bold" }
const _hoisted_113 = { class: "fw-bold" }
const _hoisted_114 = { class: "pagination mb-0 flex-wrap" }
const _hoisted_115 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_116 = ["onClick"]
const _hoisted_117 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_118 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_119 = { class: "modal-content p-15 p-md-40" }
const _hoisted_120 = { class: "modal-body" }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-md-4" }
const _hoisted_123 = { class: "form-group mb-3" }
const _hoisted_124 = { class: "col-md-4" }
const _hoisted_125 = { class: "form-group mb-3" }
const _hoisted_126 = { class: "col-md-4" }
const _hoisted_127 = { class: "form-group mb-3" }
const _hoisted_128 = { class: "col-md-4" }
const _hoisted_129 = { class: "form-group mb-3" }
const _hoisted_130 = { class: "col-md-4" }
const _hoisted_131 = { class: "form-group mb-3" }
const _hoisted_132 = { class: "col-md-4" }
const _hoisted_133 = { class: "form-group mb-3" }
const _hoisted_134 = { class: "col-md-6" }
const _hoisted_135 = { class: "form-group mb-3" }
const _hoisted_136 = { class: "col-md-6" }
const _hoisted_137 = { class: "form-group mb-3" }
const _hoisted_138 = { class: "modal-footer" }
const _hoisted_139 = {
  class: "modal fade",
  id: "modalExortToday",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_140 = { class: "modal-dialog modal-xl" }
const _hoisted_141 = { class: "modal-content" }
const _hoisted_142 = { class: "modal-body" }
const _hoisted_143 = {
  class: "modal fade",
  id: "modal_update_status",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_144 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_145 = { class: "modal-content p-15 p-md-40" }
const _hoisted_146 = { class: "modal-body" }
const _hoisted_147 = { class: "mb-3" }
const _hoisted_148 = { class: "mb-3" }
const _hoisted_149 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_150 = ["min"]
const _hoisted_151 = { class: "modal-footer" }
const _hoisted_152 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_153 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_154 = { class: "modal-content p-15 p-md-40" }
const _hoisted_155 = { class: "modal-body" }
const _hoisted_156 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_157 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_158 = { class: "modal-content p-15 p-md-40" }
const _hoisted_159 = { class: "modal-body" }
const _hoisted_160 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_161 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_162 = { class: "modal-content p-15 p-md-40" }
const _hoisted_163 = { class: "modal-body" }
const _hoisted_164 = {
  class: "modal fade",
  id: "modal_fees_edit",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_165 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_166 = { class: "modal-content p-15 p-md-40" }
const _hoisted_167 = { class: "modal-body" }
const _hoisted_168 = {
  class: "modal fade",
  id: "modal_update_price",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_169 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_170 = { class: "modal-content p-15 p-md-40" }
const _hoisted_171 = { class: "modal-body" }
const _hoisted_172 = { class: "mb-3" }
const _hoisted_173 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DateRangePopover = _resolveComponent("DateRangePopover")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_exported_today = _resolveComponent("exported-today")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!
  const _component_UpdateFeesParcel = _resolveComponent("UpdateFeesParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[50] || (_cache[50] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status",
            style: {"width":"8rem","height":"8rem"}
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.isLoader ? { 'pointer-events': 'none', opacity: '0.08' } : '']),
      class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[51] || (_cache[51] = _createElementVNode("h5", { class: "mb-0 fw-bold" }, "Liste des colis", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.filter.total) + " résultat" + _toDisplayString(_ctx.filter.total > 1 ? "s" : ""), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[53] || (_cache[53] = _createElementVNode("i", { class: "flaticon-search-interface-symbol flt-search__icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "flt-search__input",
              placeholder: "Code, téléphone, destinataire...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            (_ctx.searchTerm)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "flt-search__clear",
                  title: "Effacer",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                }, _cache[52] || (_cache[52] = [
                  _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          (_ctx.auth.can('EXPORT_PARCELS'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-outline-success",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportColis && _ctx.exportColis(...args)))
              }, _cache[54] || (_cache[54] = [
                _createElementVNode("i", { class: "flaticon-file-1 me-1" }, null, -1),
                _createTextVNode(" Export ", -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("button", _hoisted_7, [
            _cache[55] || (_cache[55] = _createElementVNode("i", { class: "ph ph-clock me-1" }, null, -1)),
            _cache[56] || (_cache[56] = _createTextVNode(" Reporté ", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.countExportToday), 1)
          ]),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-info",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reportTodayColis && _ctx.reportTodayColis(...args)))
          }, _cache[57] || (_cache[57] = [
            _createElementVNode("i", { class: "ph ph-file-xls me-1" }, null, -1),
            _createTextVNode(" .xlsx ", -1)
          ])),
          (_ctx.auth.can('ADD_PARCEL'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/add-colis",
                class: "btn btn-sm btn-success"
              }, {
                default: _withCtx(() => _cache[58] || (_cache[58] = [
                  _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                  _createTextVNode(" Nouveau Colis ", -1)
                ])),
                _: 1,
                __: [58]
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etatOptions, (opt) => {
            return (_openBlock(), _createElementBlock("button", {
              key: opt.value,
              type: "button",
              class: _normalizeClass(["flt-seg__btn", { 'is-active': (_ctx.etat_filter || '') === opt.value }]),
              "aria-pressed": (_ctx.etat_filter || '') === opt.value,
              onClick: ($event: any) => (_ctx.setEtat(opt.value))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["flt-seg__dot", `dot-${opt.tone}`]),
                "aria-hidden": "true"
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(opt.label), 1)
            ], 10, _hoisted_11))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["flt-trigger", { 'is-set': _ctx.selectedDate?.[0], 'is-open': _ctx.showCalendarBox }]),
            "aria-expanded": _ctx.showCalendarBox,
            "aria-haspopup": "dialog",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCalendar()))
          }, [
            _cache[59] || (_cache[59] = _createElementVNode("i", {
              class: "ph ph-calendar-blank flt-trigger__icon",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_14, [
              _createElementVNode("small", null, _toDisplayString(_ctx.selectedDate?.[0] ? _ctx.dateTypeLabel : "Période"), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.periodLabel), 1)
            ]),
            _cache[60] || (_cache[60] = _createElementVNode("i", {
              class: "ph ph-caret-down flt-trigger__caret",
              "aria-hidden": "true"
            }, null, -1))
          ], 10, _hoisted_13),
          (_ctx.showCalendarBox)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: "flt-backdrop",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCalendarBox = false))
                }),
                _createVNode(_component_DateRangePopover, {
                  "model-value": _ctx.selectedDate,
                  preset: _ctx.datePreset,
                  "date-type": _ctx.type_date_filter,
                  "date-types": _ctx.dateTypeOptions,
                  onApply: _ctx.applyDateRange,
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCalendarBox = false))
                }, null, 8, ["model-value", "preset", "date-type", "date-types", "onApply"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["flt-trigger flt-trigger--filters", { 'is-set': _ctx.advancedFilterCount > 0 }]),
          "aria-expanded": _ctx.filtersOpen,
          "aria-controls": "colis-filters-drawer",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filtersOpen = true))
        }, [
          _cache[61] || (_cache[61] = _createElementVNode("i", {
            class: "ph ph-sliders-horizontal flt-trigger__icon",
            "aria-hidden": "true"
          }, null, -1)),
          _cache[62] || (_cache[62] = _createElementVNode("span", { class: "flt-trigger__label" }, "Filtres", -1)),
          (_ctx.advancedFilterCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.advancedFilterCount), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_15),
        (_ctx.activeFilterCount > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "flt-reset",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetFilters()))
            }, _cache[63] || (_cache[63] = [
              _createElementVNode("i", {
                class: "ph ph-arrow-counter-clockwise",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Réinitialiser ", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      (_ctx.activeFilterCount > 0)
        ? (_openBlock(), _createBlock(_TransitionGroup, {
            key: 0,
            name: "flt-chip",
            tag: "div",
            class: "flt-chips px-15 px-md-20",
            "aria-label": "Filtres actifs"
          }, {
            default: _withCtx(() => [
              (_ctx.etat_filter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                    _cache[65] || (_cache[65] = _createElementVNode("small", null, "État", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.etat_filter) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre État",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeFilter('etat')))
                    }, _cache[64] || (_cache[64] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedDate?.[0])
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.dateTypeLabel), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.periodLabel) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Période",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.removeFilter('date')))
                    }, _cache[66] || (_cache[66] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.client_filter?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _cache[68] || (_cache[68] = _createElementVNode("small", null, "Magasin", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.client_filter.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Magasin",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeFilter('client')))
                    }, _cache[67] || (_cache[67] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.liv_filter?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _cache[70] || (_cache[70] = _createElementVNode("small", null, "Livreur", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.liv_filter.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Livreur",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.removeFilter('liv')))
                    }, _cache[69] || (_cache[69] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status_filter?.code)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _cache[72] || (_cache[72] = _createElementVNode("small", null, "Status", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.status_filter.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Status",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removeFilter('status')))
                    }, _cache[71] || (_cache[71] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.zone_filter?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _cache[74] || (_cache[74] = _createElementVNode("small", null, "Zone", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.zone_filter.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Zone",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.removeFilter('zone')))
                    }, _cache[73] || (_cache[73] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.city_filter?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                    _cache[76] || (_cache[76] = _createElementVNode("small", null, "Ville", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.city_filter.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre Ville",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.removeFilter('city')))
                    }, _cache[75] || (_cache[75] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.add_bp_filter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _cache[78] || (_cache[78] = _createElementVNode("small", null, "BPL", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.add_bp_filter === "0" ? "Non ajouté" : "Ajouté & non payé") + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": "Retirer le filtre BPL",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeFilter('bpl')))
                    }, _cache[77] || (_cache[77] = [
                      _createElementVNode("i", { class: "ph ph-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "flt-fade" }, {
          default: _withCtx(() => [
            (_ctx.filtersOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "flt-drawer-backdrop",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.filtersOpen = false))
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "flt-drawer" }, {
          default: _withCtx(() => [
            (_ctx.filtersOpen)
              ? (_openBlock(), _createElementBlock("aside", {
                  key: 0,
                  id: "colis-filters-drawer",
                  class: "flt-drawer",
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": "colis-filters-title",
                  onKeydown: _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.filtersOpen = false), ["esc"]))
                }, [
                  _createElementVNode("header", _hoisted_25, [
                    _cache[80] || (_cache[80] = _createElementVNode("div", null, [
                      _createElementVNode("span", { class: "flt-eyebrow" }, "Liste des colis"),
                      _createElementVNode("h2", { id: "colis-filters-title" }, "Filtres avancés")
                    ], -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ui-icon-btn",
                      "aria-label": "Fermer",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.filtersOpen = false))
                    }, _cache[79] || (_cache[79] = [
                      _createElementVNode("i", {
                        class: "ph ph-x",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("section", _hoisted_27, [
                      _cache[83] || (_cache[83] = _createElementVNode("h3", null, [
                        _createElementVNode("i", {
                          class: "ph ph-users-three",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Intervenants")
                      ], -1)),
                      _cache[84] || (_cache[84] = _createElementVNode("label", { class: "flt-label" }, "Magasin", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.client_filter,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.client_filter) = $event)),
                        label: "name",
                        options: _ctx.clientList,
                        onSearch: _ctx.filterClients,
                        placeholder: "Rechercher un magasin..."
                      }, {
                        "no-options": _withCtx(() => _cache[81] || (_cache[81] = [
                          _createTextVNode("Tapez pour chercher un magasin", -1)
                        ])),
                        _: 1
                      }, 8, ["modelValue", "options", "onSearch"]),
                      _cache[85] || (_cache[85] = _createElementVNode("label", { class: "flt-label" }, "Livreur", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.liv_filter,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.liv_filter) = $event)),
                        label: "name",
                        options: _ctx.livreurList,
                        onSearch: _ctx.onSearchDrivers,
                        placeholder: "Rechercher un livreur..."
                      }, {
                        "no-options": _withCtx(() => _cache[82] || (_cache[82] = [
                          _createTextVNode("Tapez pour chercher un livreur", -1)
                        ])),
                        _: 1
                      }, 8, ["modelValue", "options", "onSearch"])
                    ]),
                    _createElementVNode("section", _hoisted_28, [
                      _cache[86] || (_cache[86] = _createElementVNode("h3", null, [
                        _createElementVNode("i", {
                          class: "ph ph-package",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Colis")
                      ], -1)),
                      _cache[87] || (_cache[87] = _createElementVNode("label", { class: "flt-label" }, "Status", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.status_filter,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.status_filter) = $event)),
                        label: "name",
                        options: _ctx.status,
                        placeholder: "Tous les status"
                      }, null, 8, ["modelValue", "options"]),
                      _cache[88] || (_cache[88] = _createElementVNode("label", { class: "flt-label" }, "Ajouté au BPL", -1)),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bplOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: opt.value,
                            type: "button",
                            role: "radio",
                            class: _normalizeClass(["flt-option", { 'is-active': (_ctx.add_bp_filter || '') === opt.value }]),
                            "aria-checked": (_ctx.add_bp_filter || '') === opt.value,
                            onClick: ($event: any) => (_ctx.add_bp_filter = opt.value)
                          }, _toDisplayString(opt.label), 11, _hoisted_30))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_31, [
                      _cache[89] || (_cache[89] = _createElementVNode("h3", null, [
                        _createElementVNode("i", {
                          class: "ph ph-map-pin",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Localisation")
                      ], -1)),
                      _cache[90] || (_cache[90] = _createElementVNode("label", { class: "flt-label" }, "Zone", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.zone_filter,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.zone_filter) = $event)),
                        label: "name",
                        options: _ctx.zonesList,
                        placeholder: "Toutes les zones"
                      }, null, 8, ["modelValue", "options"]),
                      _cache[91] || (_cache[91] = _createElementVNode("label", { class: "flt-label" }, "Ville", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.city_filter,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.city_filter) = $event)),
                        label: "name",
                        options: _ctx.citiesList,
                        placeholder: "Toutes les villes"
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]),
                  _createElementVNode("footer", _hoisted_32, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.resetFilters(); _ctx.filtersOpen = false})
                    }, " Tout réinitialiser "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.applyFilters(); _ctx.filtersOpen = false})
                    }, [
                      _cache[92] || (_cache[92] = _createTextVNode(" Appliquer", -1)),
                      (_ctx.advancedFilterCount > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.advancedFilterCount) + ")", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[94] || (_cache[94] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm w-auto",
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.filter.per_page) = $event)),
            onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.changePerPage && _ctx.changePerPage(...args)))
          }, _cache[93] || (_cache[93] = [
            _createElementVNode("option", { value: 10 }, "10", -1),
            _createElementVNode("option", { value: 25 }, "25", -1),
            _createElementVNode("option", { value: 50 }, "50", -1),
            _createElementVNode("option", { value: 100 }, "100", -1),
            _createElementVNode("option", { value: 500 }, "500", -1)
          ]), 544), [
            [_vModelSelect, _ctx.filter.per_page]
          ]),
          _cache[95] || (_cache[95] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("table", _hoisted_37, [
              _cache[140] || (_cache[140] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " Code d'envoi "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Dernière mise à jour "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Destinataire "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Magasin "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Etat "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Status "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Ville "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Prix "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " ACTIONS "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " BONS ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        (row.replace === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_40, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[96] || (_cache[96] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                            ]))
                          : (row.partial === 1)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_41, [
                                _createTextVNode(_toDisplayString(row.code) + " ", 1),
                                _cache[97] || (_cache[97] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                              ]))
                            : (_openBlock(), _createElementBlock("h6", _hoisted_42, _toDisplayString(row.code), 1)),
                        (row.from_stock == 1)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_43))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.getDate(row.updated_at)), 1),
                    _createElementVNode("td", _hoisted_45, [
                      _createElementVNode("p", _hoisted_46, [
                        _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                        _cache[98] || (_cache[98] = _createTextVNode()),
                        _cache[99] || (_cache[99] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                        _cache[100] || (_cache[100] = _createTextVNode()),
                        _cache[101] || (_cache[101] = _createElementVNode("br", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_47, [
                      (row.magasin_name)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_48, "Magasin : " + _toDisplayString(row.magasin_name), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createTextVNode(_toDisplayString(row.customer_name), 1),
                            _cache[102] || (_cache[102] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.oldPhone(row.customer_phone)), 1)
                          ]))
                    ]),
                    _createElementVNode("td", _hoisted_50, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge text-outline-${_ctx.resolveUserStatusVariant(
                    row.situation
                  )}`)
                      }, _toDisplayString(_ctx.resolveStatuParcel(row.situation)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_51, [
                      (row.comment_rembourse)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_52, _toDisplayString(row.comment_rembourse), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({ '--dynamic-bg': _ctx.getBadgeConfig(row).color })
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).text) + " ", 1),
                        (_ctx.getBadgeConfig(row).date)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[103] || (_cache[103] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).date), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.getBadgeConfig(row).comment)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[104] || (_cache[104] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).comment), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 4),
                      (row.from_stock == 1 && row.stock_ready == 1 && row.status === 'NEW_PARCEL')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _cache[105] || (_cache[105] = [
                            _createElementVNode("i", { class: "ph ph-package" }, null, -1),
                            _createTextVNode(" Prêt pour la préparation ", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_54, [
                      _createElementVNode("b", null, _toDisplayString(row.city_name), 1),
                      _cache[106] || (_cache[106] = _createElementVNode("br", null, null, -1)),
                      (row.quartier && row.quartier.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(row.quartier.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_56, [
                      _createElementVNode("b", null, _toDisplayString(row.price), 1),
                      _createTextVNode(_toDisplayString(_ctx.$devis), 1),
                      _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1))
                    ]),
                    _createElementVNode("td", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _cache[122] || (_cache[122] = _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_59, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.TicketsPDF(row))
                            }, _cache[108] || (_cache[108] = [
                              _createElementVNode("i", { class: "flaticon-printing lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Ticket ", -1)
                            ]), 8, _hoisted_60)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetailSuivi(row))
                            }, _cache[109] || (_cache[109] = [
                              _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Historique ", -1)
                            ]), 8, _hoisted_61)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetails(row))
                            }, _cache[110] || (_cache[110] = [
                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ", -1)
                            ]), 8, _hoisted_62)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              target: "_blank",
                              href: `https://api.whatsapp.com/send?phone=${_ctx.SubstrPhone(
                          row.phone
                        )}&text=Client : ${row.customer_name} Téléphone : ${
                          row.customer_phone
                        } Code d'envoi : ${row.code} Destinataire : ${
                          row.receiver
                        } Téléphone : ${row.phone} Ville : ${
                          row.city_name
                        } Adresse : ${row.address} Commentaire : ${
                          row.note
                        } Produit : ${row.product_nature} Crbt : ${
                          row.price
                        } ${_ctx.$devis}`
                            }, _cache[111] || (_cache[111] = [
                              _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" WhatsApp ", -1)
                            ]), 8, _hoisted_63)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.callPhone(row.phone))
                            }, _cache[112] || (_cache[112] = [
                              _createElementVNode("i", { class: "ph ph-phone lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Appeler destinaire ", -1)
                            ]), 8, _hoisted_64)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.ShareCust(row))
                            }, _cache[113] || (_cache[113] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Partager avec vendeur ", -1)
                            ]), 8, _hoisted_65)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.ShareLivreur(row))
                            }, _cache[114] || (_cache[114] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Partager avec livreur ", -1)
                            ]), 8, _hoisted_66)
                          ]),
                          (_ctx.canSoftDelete(row))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.Destroy_Coli(row))
                                }, _cache[115] || (_cache[115] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Supprimer ", -1)
                                ]), 8, _hoisted_68)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.auth.can('PARCELS') &&
                        row.situation !== 'Facturé' &&
                        row.situation !== 'Payé' &&
                        row.situation !== 'PAID' &&
                        row.situation !== 'INVOICED' &&
                        row.invoiced === 0 &&
                        _ctx.user?.role_id === 1 &&
                        _ctx.auth.can('TRASH_PARCEL_ADMIN')
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.adminDestroy(row))
                                }, _cache[116] || (_cache[116] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Forcer suppression ", -1)
                                ]), 8, _hoisted_70)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.auth.can('PARCELS') &&
                        !_ctx.isRefundParcel(row) &&
                        (_ctx.user?.role_id === 1 || _ctx.user?.role_id === 2) &&
                        row.status !== 'NEW_PARCEL' &&
                        row.status !== 'WAITING_PICKUP' &&
                        row.status !== 'RETURNED' &&
                        row.status !== 'RETURNED_PARTIAL'
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.showUpdate(row))
                                }, _cache[117] || (_cache[117] = [
                                  _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier ", -1)
                                ]), 8, _hoisted_72)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        row.status === 'DISTRIBUTION' ||
                        (row.status === 'IN_PROGRESS' && row.invoiced === 0)
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.showStatus(row.id))
                                }, _cache[118] || (_cache[118] = [
                                  _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Changer Status ", -1)
                                ]), 8, _hoisted_74)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.auth.can('EDIT_PRICE_PARCELS') &&
                        !_ctx.isRefundParcel(row) &&
                        row.situation !== 'Facturé' &&
                        row.situation !== 'INVOICED' &&
                        row.invoiced !== 1 &&
                        row.status !== 'NEW_PARCEL' &&
                        row.status !== 'WAITING_PICKUP'
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_75, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.editPrice(row))
                                }, _cache[119] || (_cache[119] = [
                                  _createElementVNode("i", { class: "flaticon-money lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier Prix ", -1)
                                ]), 8, _hoisted_76)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.auth.can('PARCELS') &&
                        _ctx.auth.can('EDIT_FEES_PARCELS') &&
                        !_ctx.isRefundParcel(row) &&
                        (_ctx.user?.role_id === 1 || _ctx.user?.role_id === 2) &&
                        row.status !== 'NEW_PARCEL' &&
                        row.status !== 'WAITING_PICKUP' &&
                        row.invoiced === 0
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_77, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.handleFeesClick(row))
                                }, _cache[120] || (_cache[120] = [
                                  _createElementVNode("i", { class: "flaticon-money lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier Frais ", -1)
                                ]), 8, _hoisted_78)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.auth.can('PARCELS') &&
                        (_ctx.user?.role_id === 1 || _ctx.user?.role_id === 2) &&
                        (row.status === 'DELIVERED' ||
                          row.status === 'DELIVERED_PARTIAL') &&
                        row.invoiced !== 1
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_79, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.EditLivredStatut(row))
                                }, _cache[121] || (_cache[121] = [
                                  _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier Statut (Non Livré) ", -1)
                                ]), 8, _hoisted_80)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_81, [
                      _withDirectives(_createElementVNode("span", null, [
                        (row.showButtons == 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "refs-btn refs-btn--show",
                              title: "Voir Références",
                              onClick: ($event: any) => (_ctx.showParcelBons(row))
                            }, _cache[123] || (_cache[123] = [
                              _createElementVNode("i", { class: "flaticon-more" }, null, -1)
                            ]), 8, _hoisted_82))
                          : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _cache[125] || (_cache[125] = _createElementVNode("span", { class: "refs-expanded__title" }, "Références", -1)),
                                _createElementVNode("button", {
                                  class: "refs-btn refs-btn--hide",
                                  title: "Masquer Références",
                                  onClick: _withModifiers(($event: any) => (row.showButtons = 0), ["stop"])
                                }, _cache[124] || (_cache[124] = [
                                  _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                                ]), 8, _hoisted_85)
                              ]),
                              _createElementVNode("ul", _hoisted_86, [
                                (row.delivery_note != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_87, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.delivery_note, '1'))
                                      }, [
                                        _cache[126] || (_cache[126] = _createElementVNode("i", { class: "ri-file-list-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.delivery_note_ref), 1)
                                      ], 8, _hoisted_88)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.delivery_note_s != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_89, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.delivery_note_s, '2'))
                                      }, [
                                        _cache[127] || (_cache[127] = _createElementVNode("i", { class: "ri-file-list-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.delivery_note_s_ref), 1)
                                      ], 8, _hoisted_90)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.reception_note_ref != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_91, [
                                      _createElementVNode("a", {
                                        href: `/Reception/AddHC/${row.customer}/${row.reception_note_ref}`
                                      }, [
                                        _cache[128] || (_cache[128] = _createElementVNode("i", { class: "ri-file-received-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.reception_note_ref), 1)
                                      ], 8, _hoisted_92)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.sent && row.bons.sent.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(row.bons.sent, (sn, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'sent-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(sn.sent_id, '3'))
                                        }, [
                                          _cache[129] || (_cache[129] = _createElementVNode("i", { class: "ri-send-plane-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(sn.sent_ref), 1)
                                        ], 8, _hoisted_93)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.arrivage && row.bons.arrivage.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(row.bons.arrivage, (sn, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'arr-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(sn.note_id, '10'))
                                        }, [
                                          _cache[130] || (_cache[130] = _createElementVNode("i", { class: "ri-inbox-archive-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(sn.note_ref), 1)
                                        ], 8, _hoisted_94)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.dis && row.bons.dis.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(row.bons.dis, (bn, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'dis-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(bn.dis_id, '4'))
                                        }, [
                                          _cache[131] || (_cache[131] = _createElementVNode("i", { class: "ri-map-pin-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(bn.dis_ref), 1)
                                        ], 8, _hoisted_95)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.pointage && row.bons.pointage.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(row.bons.pointage, (bnp, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'pt-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(bnp.note_id, '9'))
                                        }, [
                                          _cache[132] || (_cache[132] = _createElementVNode("i", { class: "ri-check-double-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(bnp.note_ref), 1)
                                        ], 8, _hoisted_96)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.pay && row.bons.pay.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(row.bons.pay, (bn, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'pay-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(bn.pay_id, '6'))
                                        }, [
                                          _cache[133] || (_cache[133] = _createElementVNode("i", { class: "ri-money-dollar-circle-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(bn.pay_ref), 1)
                                        ], 8, _hoisted_97)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.pay_z && row.bons.pay_z.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList(row.bons.pay_z, (bz, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'payz-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          href: `/edit_payments_note_zone/ref/${bz.pay_z_ref}`
                                        }, [
                                          _cache[134] || (_cache[134] = _createElementVNode("i", { class: "ri-money-dollar-circle-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(bz.pay_z_ref), 1)
                                        ], 8, _hoisted_98)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                (row.rn_a_ref != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_99, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.rn_a, '7'))
                                      }, [
                                        _cache[135] || (_cache[135] = _createElementVNode("i", { class: "ri-arrow-go-back-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.rn_a_ref), 1)
                                      ], 8, _hoisted_100)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.rn_c_ref != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_101, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.rn_c, '7'))
                                      }, [
                                        _cache[136] || (_cache[136] = _createElementVNode("i", { class: "ri-arrow-go-back-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.rn_c_ref), 1)
                                      ], 8, _hoisted_102)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.rn_rec_ref && row.rn_rec != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.rn_rec, '7'))
                                      }, [
                                        _cache[137] || (_cache[137] = _createElementVNode("i", { class: "ri-arrow-go-back-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.rn_rec_ref), 1)
                                      ], 8, _hoisted_104)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.rn_e_ref && row.rn_e_ref != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.voirItem(row.rn_e, '8'))
                                      }, [
                                        _cache[138] || (_cache[138] = _createElementVNode("i", { class: "ri-arrow-go-back-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(row.rn_e_ref), 1)
                                      ], 8, _hoisted_106)
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.bons && row.bons.inv && row.bons.inv.length != 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 13 }, _renderList(row.bons.inv, (invoice, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: 'inv-'+index
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.voirItem(invoice.invoice_id, '5'))
                                        }, [
                                          _cache[139] || (_cache[139] = _createElementVNode("i", { class: "ri-bill-line" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(invoice.invoice_code), 1)
                                        ], 8, _hoisted_107)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                      ], 512), [
                        [_vShow, _ctx.showRefs]
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _cache[142] || (_cache[142] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm w-auto",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.filter.per_page) = $event)),
              onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.changePerPage && _ctx.changePerPage(...args)))
            }, _cache[141] || (_cache[141] = [
              _createElementVNode("option", { value: 10 }, "10", -1),
              _createElementVNode("option", { value: 25 }, "25", -1),
              _createElementVNode("option", { value: 50 }, "50", -1),
              _createElementVNode("option", { value: 100 }, "100", -1),
              _createElementVNode("option", { value: 500 }, "500", -1)
            ]), 544), [
              [_vModelSelect, _ctx.filter.per_page]
            ]),
            _cache[143] || (_cache[143] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
          ]),
          _createElementVNode("p", _hoisted_110, [
            _cache[144] || (_cache[144] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_111, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[145] || (_cache[145] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_112, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[146] || (_cache[146] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.filter.total), 1),
            _cache[147] || (_cache[147] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_114, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Previous",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
                }, _cache[148] || (_cache[148] = [
                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedPages, (page, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (page === '...')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_115, _cache[149] || (_cache[149] = [
                        _createElementVNode("span", { class: "page-link" }, "…", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass(["page-item", { active: _ctx.filter.current_page === page }])
                      }, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "page-link",
                          onClick: ($event: any) => (_ctx.goToPage(page as number))
                        }, _toDisplayString(page), 9, _hoisted_116)
                      ], 2))
                ], 64))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Next",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
                }, _cache[150] || (_cache[150] = [
                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_117, [
      _createElementVNode("div", _hoisted_118, [
        _createElementVNode("div", _hoisted_119, [
          _cache[162] || (_cache[162] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Filtrer"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("form", _hoisted_121, [
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _cache[151] || (_cache[151] = _createElementVNode("label", null, "Magasin:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.client_filter,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.client_filter) = $event)),
                    label: "name",
                    options: _ctx.clientList,
                    onSearch: _ctx.filterClients
                  }, null, 8, ["modelValue", "options", "onSearch"])
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _cache[152] || (_cache[152] = _createElementVNode("label", null, "Zone:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.zone_filter,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.zone_filter) = $event)),
                    label: "name",
                    options: _ctx.zonesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  _cache[153] || (_cache[153] = _createElementVNode("label", null, "Ville:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.city_filter,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.city_filter) = $event)),
                    label: "name",
                    options: _ctx.citiesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _cache[155] || (_cache[155] = _createElementVNode("label", null, "Livreur:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.liv_filter,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.liv_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.livreurList,
                    onSearch: _ctx.onSearchDrivers
                  }, {
                    "no-options": _withCtx(() => _cache[154] || (_cache[154] = [
                      _createTextVNode(" Taper un mot pour chercher un livreur ", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "options", "onSearch"])
                ])
              ]),
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _cache[156] || (_cache[156] = _createElementVNode("label", null, "Etat:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.etat_filter,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.etat_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.etatList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _cache[157] || (_cache[157] = _createElementVNode("label", null, "Status:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.status_filter,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.status_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.status
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _cache[159] || (_cache[159] = _createElementVNode("label", null, "Par Date de:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.type_date_filter) = $event)),
                    class: "form-control"
                  }, _cache[158] || (_cache[158] = [
                    _createStaticVNode("<option value=\"ADD_DATE\" data-v-5bf9a80f>Date de création</option><option value=\"LAST_UPDATE\" data-v-5bf9a80f>Dernière Mise à jour</option><option value=\"PICKED_DATE\" data-v-5bf9a80f>Date de ramassage</option><option value=\"SENT_DATE\" data-v-5bf9a80f>Date d&#39;expédition</option><option value=\"DELIVERY_DATE\" data-v-5bf9a80f>Date de livraison</option><option value=\"POSTPONED_DATE\" data-v-5bf9a80f>Date reportée</option>", 6)
                  ]), 512), [
                    [_vModelSelect, _ctx.type_date_filter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", _hoisted_137, [
                  _cache[161] || (_cache[161] = _createElementVNode("label", null, "Ajouté Au BPL:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.add_bp_filter) = $event)),
                    class: "form-control"
                  }, _cache[160] || (_cache[160] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "0" }, "Non Ajouté Au BPL", -1),
                    _createElementVNode("option", { value: "1" }, "Ajouté Au BPL et Non Payé", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.add_bp_filter]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_138, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args))),
              class: "btn btn-primary"
            }, " Annuler "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "btn btn-warning"
            }, " Appliquer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_139, [
      _createElementVNode("div", _hoisted_140, [
        _createElementVNode("div", _hoisted_141, [
          _cache[163] || (_cache[163] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Colis reportés pour aujourd'hui"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_142, [
            _createVNode(_component_exported_today)
          ]),
          _cache[164] || (_cache[164] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_143, [
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _cache[168] || (_cache[168] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Changer le statut du colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_147, [
                _cache[165] || (_cache[165] = _createElementVNode("label", {
                  for: "statut",
                  class: "form-label"
                }, "Statut", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  id: "statut",
                  modelValue: _ctx.statutColi,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.statutColi) = $event)),
                  label: "name",
                  placeholder: "Choisir un statut",
                  options: _ctx.StatusList2
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _cache[166] || (_cache[166] = _createElementVNode("label", {
                  for: "note",
                  class: "form-label"
                }, "Commentaire", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.commentStatu) = $event)),
                  name: "note",
                  rows: "3",
                  class: "form-control",
                  placeholder: "Écrire un commentaire ici..."
                }, null, 512), [
                  [_vModelText, _ctx.commentStatu]
                ])
              ]),
              (
                _ctx.statutColi.code === 'POSTPONED' ||
                _ctx.statutColi.code === 'PROGRAMED'
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                    _cache[167] || (_cache[167] = _createElementVNode("label", {
                      for: "datepicker-dateformat2",
                      class: "form-label"
                    }, "Date le :", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "datepicker-dateformat2",
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.date_retour) = $event)),
                      class: "form-control",
                      min: _ctx.minDate
                    }, null, 8, _hoisted_150), [
                      [_vModelText, _ctx.date_retour]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_151, [
            (_ctx.auth.can('PARCELS'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.editPriceStatut && _ctx.editPriceStatut(...args)))
                }, " Enregistrer "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_152, [
      _createElementVNode("div", _hoisted_153, [
        _createElementVNode("div", _hoisted_154, [
          _cache[169] || (_cache[169] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_155, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpen,
                  status: _ctx.status
                }, null, 8, ["colisId", "isOpen", "status"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_156, [
      _createElementVNode("div", _hoisted_157, [
        _createElementVNode("div", _hoisted_158, [
          _cache[170] || (_cache[170] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_159, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpen
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_160, [
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("div", _hoisted_162, [
          _cache[171] || (_cache[171] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_163, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRecords,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_164, [
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _cache[172] || (_cache[172] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier les frais"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_167, [
            (_ctx.rowUpdateFees)
              ? (_openBlock(), _createBlock(_component_UpdateFeesParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdateFees,
                  getRecords: _ctx.getRecords,
                  isOpenFees: _ctx.isOpenFees,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenFees", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_168, [
      _createElementVNode("div", _hoisted_169, [
        _createElementVNode("div", _hoisted_170, [
          _cache[175] || (_cache[175] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modification du prix de colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_171, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_172, [
                _cache[173] || (_cache[173] = _createElementVNode("label", {
                  for: "price",
                  class: "form-label"
                }, "Prix", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "price",
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.PriceColis.price) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.PriceColis.price]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_173, [
            _cache[174] || (_cache[174] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Annuler ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.EditPriceColis && _ctx.EditPriceColis(...args)))
            }, " Enregistrer ")
          ])
        ])
      ])
    ])
  ], 64))
}